module.exports = __webpack_public_path__ + "42131f8c4e8353b7a4ebaa7bd4f97265.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/eldar-320.jpg
// module id = 259
// module chunks = 0